import { combineReducers } from "redux";
import { appDetails } from "./app";
import { loginDetails } from "./login";
import { toasterDetails } from "./toaster";
import { confirmDialogDetails } from "./confirmDialog";
import { modalPopupDetails } from "./modalPopup";
import { cartDetails } from "./cart";
import { dropdownDetails } from "./dropdown";
import { galleryPopupDetails } from "./galleryPopup";

const rootReducer = combineReducers({
  appDetails: appDetails,
  loginDetails: loginDetails,
  toasterDetails: toasterDetails,
  confirmDialogDetails: confirmDialogDetails,
  modalPopupDetails: modalPopupDetails,
  cartDetails: cartDetails,
  dropdownDetails: dropdownDetails,
  galleryPopupDetails: galleryPopupDetails
});

export default rootReducer;